import React, { Component } from 'react';
import { View, TouchableOpacity, ScrollView } from 'react-native';

import Text from '../components/shared/Text';
import Button from '../components/shared/Button';
import Card, { WIDTH as CARD_WIDTH } from '../components/shared/Card';
import { styles, THING_ITEM_WIDTH } from './shop/Screen';
import { confirm } from '../components/shared/Alert';

import { WINDOW_WIDTH, PADDING, BUTTON_HEIGHT } from '../components/styleConstants';

import { getBuilding } from '../utils/buildingUtils';
import { isDressable } from '../utils/thingUtils';
import { getLocalValue, t, action } from '../utils/appUtils';

import appStore from '../stores/app';
import heroStore from '../stores/hero';

import { buildingAction } from '../lib/apiCalls';

import logImport from '../lib/log';
const log = logImport as (name: string, params?: Record<string, any>) => void;

import {
  filterThings,
  FilterPicker as ThingsFilterPicker,
  styles as inventoryStyles,
} from '../components/Inventory/Inventory';

import ThingItem from '../components/common/ThingItem';

import { BuildingType } from '../lib/types';

import {
  getThingRepairCost,
  isDressed,
  getDrassedRedThingsRepairCost,
} from '../utils/warriorUtils';

import { BUILDING_MODULES } from '../lib/constants';

type Props = {
  id: string;
};

type State = {
  filter: string | null;
};

export default class Forge extends Component<Props, State> {
  state: State = {
    filter: null,
  };

  building: BuildingType;

  constructor(props: Props) {
    super(props);
    this.building = getBuilding(appStore.initData.buildings, props.id)!;
  }

  renderItems() {
    const { filter } = this.state;
    const { things } = appStore.initData;
    return heroStore.hero.things
      .filter((item: any) => filterThings(things, item.thing, filter, isDressable))
      .map((warriorThing: any, index: number) => (
        <ThingItem
          width={THING_ITEM_WIDTH}
          key={warriorThing.id}
          warrior={heroStore.hero}
          warriorThingOrId={warriorThing}
          index={index}
          renderMore={({ warriorThing }: { warriorThing: any }) => {
            return isDressed(warriorThing) ? <Text bold>{t('things.dressed')}</Text> : null;
          }}
          actionsRenderer={() => (
            <View>
              {[10, undefined].map((count) => {
                const cost = getThingRepairCost(heroStore.hero, warriorThing.id, count);
                return cost > 0 &&
                  ((count && count < warriorThing.stabilityAll - warriorThing.stabilityLeft) ||
                    !count) ? (
                  <Button
                    key={count || 'all'}
                    sizeObj={{
                      width: 155,
                      height: BUTTON_HEIGHT,
                    }}
                    onPress={() =>
                      action(async () => {
                        log('repairAction', {
                          warriorLogin: heroStore.hero.login,
                          warriorThingId: warriorThing.id,
                          count,
                        });
                        await buildingAction(
                          this.building.id,
                          BUILDING_MODULES.FORGE.ACTIONS.REPAIR,
                          {
                            warriorThingId: warriorThing.id,
                            count,
                          },
                        );
                        appStore.showMessage({
                          type: 'success',
                          text: t('forge.thingWasRepaired'),
                        });
                      })
                    }
                    disabled={cost > heroStore.hero.money}
                    style={{ marginTop: PADDING }}
                    hitSlop={{
                      top: 0,
                      bottom: 0,
                    }}
                  >
                    {`${t(count ? 'forge.repairThing' : 'forge.repairAllThing', {
                      count,
                    }).toUpperCase()} ${String(cost)}`}
                  </Button>
                ) : null;
              })}
            </View>
          )}
        />
      ));
  }

  render() {
    const { filter } = this.state;

    const drassedRedThingsRepairCost = getDrassedRedThingsRepairCost(
      heroStore.hero,
      appStore.initData.things,
    );
    return (
      <View>
        <View style={{ width: WINDOW_WIDTH - CARD_WIDTH - 3 * PADDING }}>
          <View style={{ height: BUTTON_HEIGHT, flexDirection: 'row' }}>
            <ThingsFilterPicker
              value={filter}
              filter={(key: any) => isDressable({ type: key })}
              onChange={(value: string) => {
                this.setState({ filter: value });
              }}
              style={{ marginRight: PADDING }}
            />
            {drassedRedThingsRepairCost > 0 ? (
              <Button
                sizeObj={{
                  width: 205,
                  height: BUTTON_HEIGHT,
                }}
                disabled={drassedRedThingsRepairCost > heroStore.hero.money}
                onPress={() => {
                  action(async () => {
                    confirm(
                      t('forge.repairEquippedBrokenConfirm', {
                        price: drassedRedThingsRepairCost,
                      }),
                      async () => {
                        await buildingAction(
                          this.building.id,
                          BUILDING_MODULES.FORGE.ACTIONS.REPAIRE_ALL_RED,
                        );
                        appStore.showMessage({
                          type: 'success',
                          text: t('forge.equippedBrokenItemsRepaired'),
                        });
                      },
                    );
                  });
                }}
              >
                {`${t('forge.repairEquippedBroken')} ${String(
                  drassedRedThingsRepairCost,
                )}`.toUpperCase()}
              </Button>
            ) : null}
          </View>
          <ScrollView style={inventoryStyles.container}>{this.renderItems()}</ScrollView>
        </View>
        <Card
          title={getLocalValue(this.building)}
          style={{
            position: 'absolute',
            right: 0,
          }}
        >
          <View style={{ flexDirection: 'row' }}>
            <TouchableOpacity hitSlop={{ right: 20 }}>
              <Text bold style={styles.activeItem}>
                {t('forge.repair')}
              </Text>
            </TouchableOpacity>
          </View>
        </Card>
      </View>
    );
  }
}
